import React from "react";
import { connect } from "react-redux";
import { Accordion, Button, ButtonGroup, Card, Col, Container, Form, Image, Pagination, ProgressBar, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import StarRatings from "react-star-ratings";
import VoiceButton from "../../VoiceButton/VoiceButton";
import mathProblemsByDatabaseId from "../../../common-util/MathProblems/mathProblemsById";
import { getRandomSuccessImage, getRandomFailureImage } from "./../../../images/evaluationImages";
import { updateMathRecordsInDB } from "./../../../actions";

const id = "m1"; // will update later for automation

class PlayGround extends React.Component {
  constructor(props){
    super(props);
    this.state={
      problemsObj : mathProblemsByDatabaseId["m1"].generateProblems(20),
      progress: [], // array of "true" or "false", or "unresolved"
      currentProblemId: 0,
      userAnswer: "",
      isComplete: false,
      currentResultDisplay: false,
      totalStars: 0
    }
  }

  componentDidMount() {
    if (this.props.mathRecords[id] === undefined || this.props.mathRecords[id] <= 500) {
      this.setState({totalStars: this.state.problemsObj.problems.length});
    } else {
      this.setState({totalStars: Math.floor(this.state.problemsObj.problems.length/5)});
    }
  }

  setPagination = (totalNumberOfProblems, numberOfSolvedProblems, numberOfFailedProblems) => {
    let items = [];
    let subItems = [];
    for (let problemId = 0; problemId < totalNumberOfProblems; problemId++) {
      subItems.push(
        <Pagination.Item 
          key={problemId}
          value={problemId}
          active={this.state.currentProblemId === problemId}
        >
          {
            this.state.progress[problemId] === "true" ? 
              <i className="fas fa-check" value={problemId}/> : 
              this.state.progress[problemId] === "false" ? 
                <i className="fas fa-times text-danger" value={problemId}/> :
                <i className="fas fa-pencil-alt" value={problemId} />
          }
        </Pagination.Item>,
      );
      if (problemId % 5 === 4) {
        items.push(subItems);
        subItems = [];
      }
    }
    const paginationBasic = (
      <Container>
        {
          items.map(
            (subItems, index) => {
              return (
                <Pagination
                  key={index} 
                  onClick={(e)=>{this.setState({currentProblemId: Number(e.target.attributes.value.value), userAnswer:""})}}
                >
                  {subItems}
                </Pagination>
              );
            }
          )
        }
        {
          totalNumberOfProblems === numberOfSolvedProblems + numberOfFailedProblems &&
            <Button variant={"danger"} onClick={this.completeExcise}>
              {
                this.props.userId ? 
                  <FormattedMessage id="math.complete_update" defaultMessage="Complete and Save stars"/> : 
                  <FormattedMessage id="math.complete_no_update" defaultMessage="Complete the excise"/>
              }
            </Button> 
        }
      </Container>
    );

    return paginationBasic;
  }

  completeExcise = () => {
    if(this.props.userId) {
      const numberOfCompletedProblems = this.state.progress.filter(value => value === "true").length;
      const mathId = id;
      this.props.updateMathRecordsInDB({mathId,numberOfCompletedProblems});
    }
    this.setState({isComplete: true});
  }

  setCurrentResultDisplay = () => {
    const progress = [...this.state.progress];
    const totalProblems = this.state.problemsObj.problems.length;
    const problemId = this.state.currentProblemId;
    const isCorrect = progress[problemId];
    const userAnswer = this.state.userAnswer;
    if (userAnswer === "" || this.state.currentResultDisplay === false) {
      return null;
    }
    if (isCorrect === "true") {
      return (
        <Row>
          <Col sm={2}>
            <Image 
              style={{width:"100px"}}
              src={getRandomSuccessImage()} 
            />
          </Col>
          <Col sm={10}>
            <h3 className="text-success"><FormattedMessage id="math.correct_answer" defaultMessage="Congratulations! The Answer is correct." /></h3>
            <ButtonGroup>
              <Button 
                variant="outline-primary"
                disabled={problemId <=0 }
                onClick={()=>{this.setState({currentProblemId: problemId-1, currentResultDisplay: false, userAnswer:""})}}
              >
                <FormattedMessage id="math.previouspage" defaultMessage="Previous"/>
              </Button>
              <Button
                variant="outline-primary"
                disabled={problemId >= totalProblems-1}
                onClick={()=>{this.setState({currentProblemId: problemId+1, currentResultDisplay: false, userAnswer:""})}}
              >
                <FormattedMessage id="math.nextPage" defaultMessage="Next"/>
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
      );
    } else if(isCorrect === "false"){
      return (
        <Row>
          <Col sm={2}>
            <Image 
              style={{width:"100px"}}
              src={getRandomFailureImage()} 
            />
          </Col>
          <Col sm={10}>
            <h3 className="text-success"><FormattedMessage id="math.wrong_answer" defaultMessage="Sorry, the answer is wrong. Please try again." /></h3>
            <ButtonGroup>
              <Button 
                variant="outline-primary"
                disabled={problemId <=0 }
                onClick={()=>{this.setState({currentProblemId: problemId-1, currentResultDisplay: false, userAnswer:""})}}
              >
                <FormattedMessage id="math.previouspage" defaultMessage="Previous"/>
              </Button>
              <Button
                variant="outline-primary"
                disabled={problemId >= totalProblems-1}
                onClick={()=>{this.setState({currentProblemId: problemId+1, currentResultDisplay: false, userAnswer:""})}}
              >
                <FormattedMessage id="math.nextPage" defaultMessage="Next"/>
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
      );
    } else {
      return null;
    }
  }

  getSummaryScreen = () => {
    const problems = this.state.problemsObj.problems;
    const progress = this.state.progress;
    const totalNumberOfProblems = problems.length;
    const successProblems = [];
    const failureProblems = [];

    for (let i=0; i<totalNumberOfProblems; i++) {
      if (progress[i] === "true") {successProblems.push(problems[i]);}
      if (progress[i] === "false") {failureProblems.push(problems[i]);}
    }
    console.log(successProblems, failureProblems )
    return (
      <Row>
        <Col sm={3}>
          <Image 
            src={successProblems.length/totalNumberOfProblems>0.6 ? getRandomSuccessImage() : getRandomFailureImage()}
            style={{width:"250px"}}
          />
        </Col>
        <Col sm={9}>
          {
            this.props.userId &&
            <h3>
              <FormattedMessage 
                id="math.summary.start_win" defaultMessage="You won {value} stars." 
                values={{value: Math.floor(successProblems.length/totalNumberOfProblems*this.state.totalStars)}}
              />
            </h3>
          }
          <Accordion defaultActiveKey="0">
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                  <FormattedMessage id="math.summary.number_failure" defaultMessage="Number of Wrong Answers: " /> {failureProblems.length}
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  { failureProblems.length === 0 ? 
                    <p><FormattedMessage id="math.everythingiscorrect" defaultMessage="Everything is correct. Great Job!" /></p> :
                    failureProblems.map((value, index) => {
                      return(
                        <div>
                          <p>
                            <FormattedMessage id="math.question" defaultMessage="Question: " />&nbsp;&nbsp;{value.question}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <FormattedMessage id="math.correct_answer1" defaultMessage="Corrected answer: " />&nbsp;&nbsp;{value.answer}
                          </p>
                        </div>
                      );
                    })
                  }
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey="1">
                  <FormattedMessage id="math.summary.number_success" defaultMessage="Number of Corrected Answers: " /> {successProblems.length}
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  {
                    successProblems.length === 0 ? 
                      <p><FormattedMessage id="math.nothingiscorrect" defaultMessage="You solved 0 problems." /></p> :
                      successProblems.map((value, index) => {
                        return(
                          <div>
                            <p>
                              <FormattedMessage id="math.question" defaultMessage="Question: " />&nbsp;&nbsp;{value.question}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <FormattedMessage id="math.correct_answer2" defaultMessage="Corrected answer: " />&nbsp;&nbsp;{value.answer}
                            </p>
                          </div>
                        );
                      })
                  }
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
          <hr />
          <Button 
            variant={"success"}
            onClick={()=>{
              this.setState({
                problemsObj : mathProblemsByDatabaseId["m1"].generateProblems(20),
                progress: [], // array of "true" or "false", or "unresolved"
                currentProblemId: 0,
                userAnswer: "",
                isComplete: false,
                currentResultDisplay: false,
                // totalStars: 0
              })}
            }
          >
            <FormattedMessage id="math.try_again" defaultMessage="Try Again" />
          </Button>
        </Col>
      </Row>
    );
  }  

  onSubmitAnswer = (event) => {
    event.preventDefault();
    const userAnswer = this.state.userAnswer;
    const problemId = this.state.currentProblemId;
    const problems = this.state.problemsObj.problems;
    const currentProblem = problems[problemId];
    const realAnswer = currentProblem.answer;
    const progress = [...this.state.progress];
    //console.log(userAnswer, realAnswer, progress);
    // eslint-disable-next-line eqeqeq
    if (userAnswer == realAnswer) {
      progress[problemId] = "true";
    } else {
      progress[problemId] = "false";
    }
    
    this.setState({progress, currentResultDisplay: true});
  }

  render() {
    const problems = this.state.problemsObj.problems;
    const numberOfProblems = problems.length;
    const currentProblem = problems[this.state.currentProblemId];
    const solvedProblems = [...this.state.progress].filter(element=> element==="true").length;
    const failedProblems = [...this.state.progress].filter(element=> element==="false").length;
    // console.log(currentProblem);
    const question = currentProblem.question;
    
    return <div id={this.props.background} style={{paddingBottom: "20vh"}}>
      <Container style={{paddingTop:"5vh"}}>
        <h1>{this.state.problemsObj.problemDescription}</h1>
        <ProgressBar >
          <ProgressBar now={solvedProblems} max={numberOfProblems}/>
          <ProgressBar variant="danger" now={failedProblems} max={numberOfProblems}/>
        </ProgressBar>
        <hr />
        {
          !this.state.isComplete &&
          <Row>
            <Col sm={9}>
              <h2>{currentProblem.statement}</h2>
              <br />
              <h3>
                <FormattedMessage id="math.question" defaultMessage="Question: " />&nbsp;{question}
                <VoiceButton text={question.replace("____","")} lang={this.props.language}/>
              </h3>
              <h3>
                <Row className="container">
                  <FormattedMessage id="math.answer" defaultMessage="Answer: " />&nbsp;&nbsp; 
                  <Form onSubmit={this.onSubmitAnswer}>
                    <Form.Row>
                      <Col>
                        <Form.Control
                          type="number"
                          value={this.state.userAnswer}
                          onChange={(e)=>{this.setState({userAnswer: e.target.value, currentResultDisplay: false})}}
                        />
                      </Col>
                      <Col>
                        <ButtonGroup>
                          <Button type="submit" variant="outline-primary"><FormattedMessage id="math.submit" defaultMessage="Submit"/></Button>
                          <Button variant="outline-dark" onClick={()=>{this.setState({userAnswer: "", currentResultDisplay:false})}}>
                            <FormattedMessage id="math.clear" defaultMessage="Clear"/>
                          </Button>
                        </ButtonGroup>
                      </Col>
                    </Form.Row>
                  </Form>
                </Row>
              </h3>
            </Col>
            <Col sm={3}>
              {this.setPagination(numberOfProblems, solvedProblems, failedProblems)}
            </Col>
          </Row>
        }
        {
          !this.state.isComplete && this.setCurrentResultDisplay()
        }
        {
          this.state.isComplete && this.getSummaryScreen()
        }
        <hr />
        <StarRatings
                rating={solvedProblems/numberOfProblems*this.state.totalStars}
                starRatedColor="gold"
                starEmptyColor="grey"
                numberOfStars={this.state.totalStars}
                name='rating'
                starDimension="20px"
              />
      </Container>
    </div>
  };
}

const mapStateToProps = (state) => {
  return {
    background: state.userSettings.background,
    language: state.userSettings.language,
    userId: state.user.userId,
    mathRecords: state.userRecords.mathExercise,
  };
}

export default connect(mapStateToProps, {updateMathRecordsInDB})(PlayGround);